import { isPlatformServer } from "@angular/common";
import {
  AfterContentInit,
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  PLATFORM_ID
} from '@angular/core';
import { ScreenSizeService } from "../../services/screen-size.service";

export type BootstrapScreenDimensionId = "xs" | "sm" | "md" | "lg" | "xl" | "xxl"
export interface BootstrapScreenWidthItem {
  id: BootstrapScreenDimensionId,
  class: string
}
export interface ViewportSize {
  x: number
  y: number
}
@Component({
    selector: 'gea-shop-size-detector',
    templateUrl: './size-detector.component.html',
    styleUrls: ['./size-detector.component.scss'],
    standalone: false
})
export class SizeDetectorComponent implements AfterViewInit, OnInit, AfterContentInit {
  constructor(
      private elementRef: ElementRef,
      @Inject(ScreenSizeService) private screenSizeService: ScreenSizeService,
      @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.sizes = [
      { id: "xs", class: `d-block d-sm-none` },
      { id: "sm", class: `d-none d-sm-block d-md-none` },
      { id: "md", class: `d-none d-md-block d-lg-none` },
      { id: "lg", class: `d-none d-lg-block d-xl-none` },
      { id: "xl", class: `d-none d-xl-block d-xxl-none` },
      { id: "xxl", class: `d-none d-xxl-block` }
    ]
  }

  ngAfterContentInit(): void {
    this.onScreenSizeChange()
  }

  ngOnInit(): void {
    this.onScreenSizeChange()
  }

  lastSize: BootstrapScreenDimensionId | undefined = undefined
  prefix = 'cxy-';
  sizes: BootstrapScreenWidthItem[]

  @HostListener("window:resize", [])

  ngAfterViewInit() {
    this.onScreenSizeChange();
  }

  private onScreenSizeChange() {
    if (isPlatformServer(this.platformId)) return

    this.screenSizeService.getViewportSizeChangeSubject().next({ x: window.innerWidth, y: window.innerHeight })

    let currentSize = this.sizes.find(x => {
      const el = this.elementRef.nativeElement.querySelector(`.${this.prefix}${x.id}`);
      if (! el) return false
      return window.getComputedStyle(el).display != 'none'
    });

    if (! currentSize) {
      currentSize = this.sizes[0]
    }

    if (this.lastSize !== currentSize.id) {
      this.lastSize = currentSize.id
      this.screenSizeService.getDimensionChangeSubject().next(currentSize.id)
    }
  }
}
